<template>
  <div class="component-breadcrumbs">
    <component
      v-for="(route, i) in breadcrumbs"
      class="breadcrumb-route"
      :is="route.name && i + 1 < breadcrumbs.length ? 'router-link' : 'span'"
      :key="i"
      :to="{ name: route.name, params: route.params }"
    >
      <span>
        {{ route.title }}
      </span>
      <div class="divider" v-if="i + 1 !== breadcrumbs.length">/</div>
    </component>
  </div>
</template>
<script>
import BreadcrumbsMixin from "@/mixins/breadcrumbs";
export default {
  mixins: [BreadcrumbsMixin]
};
</script>
<style lang="scss" scoped>
.component-breadcrumbs {
  display: flex;
  flex-wrap: wrap;

  .breadcrumb-route {
    display: flex;

    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    color: $neutral-500;

    .divider {
      width: 24px;
      font-size: 16px;
      text-align: center;
    }
  }
  a:hover {
    color: $neutral-700;
    text-decoration: none;
  }

  @media screen and (max-width: 767px) {
    .breadcrumb-route {
      gap: 4px;
      .divider {
        width: 20px;
        font-size: 12px;
        line-height: 20px;
      }
    }
  }
}
</style>
